import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useLenis } from "@/lib/useLenis";
import { track } from "@/lib/track";

import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Manifesto from "@/components/landing/Manifesto";
import Journey from "@/components/landing/Journey";
import Experience from "@/components/landing/Experience";
import Marquee from "@/components/landing/Marquee";
import Instructor from "@/components/landing/Instructor";
import Pricing from "@/components/landing/Pricing";
import Audience from "@/components/landing/Audience";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";
import MobileCTA from "@/components/landing/MobileCTA";

function Landing() {
  useLenis();

  // Scroll depth tracking
  useEffect(() => {
    const marks = new Set();
    const targets = [25, 50, 75, 100];
    const onScroll = () => {
      const doc = document.documentElement;
      const pct =
        (window.scrollY / (doc.scrollHeight - window.innerHeight)) * 100;
      targets.forEach((t) => {
        if (pct >= t && !marks.has(t)) {
          marks.add(t);
          track("scroll_depth", { pct: t });
        }
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <main className="relative grain min-h-screen overflow-hidden">
      <Nav />
      <Hero />
      <Marquee />
      <Manifesto />
      <Journey />
      <Experience />
      <Instructor />
      <Pricing />
      <Audience />
      <FAQ />
      <FinalCTA />
      <Footer />
      <MobileCTA />
    </main>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
